import { getHtmlLanguage } from 'utils/helpers'
import { createContext, PropsWithChildren, useContext, useMemo, useState } from 'react';
import Messages, {catalogToMessages} from "models/messages";
import MessagesType from "models/messages-type";

declare var messagesCatalog: MessagesType
const catalog = catalogToMessages(messagesCatalog)

export function findCatalogueByHtmlLang(): Messages {
  return catalog
}

export interface LanguageContextState {
  msg: Messages
}

export function findInitialLanguageMessages() {
  return catalog
}

export const LanguageContext = createContext<LanguageContextState>({
  msg: catalog
});

export function LanguageContextProvider(props: PropsWithChildren<{}>) {
  const [language, setLanguage] = useState<Messages>(() => findInitialLanguageMessages());
  const languageContextState = useMemo<LanguageContextState>(() => ({
    msg: language,
  }), [language.locale_code])
  
  return <LanguageContext.Provider value={languageContextState}>
    {props.children}
  </LanguageContext.Provider>
}

export function useTranslation(): LanguageContextState {
  const ctx = useContext(LanguageContext);
  return ctx;
}

export function useMessages(): Messages {
  const ctx = useContext(LanguageContext);
  return ctx.msg;
}

